import { useState } from 'react'

import { TagInput } from '@/components/ui/tag-input'
import { Demo, DsSection } from '../primitives'
import { FREIGHT_SUGGESTION_GROUPS, FREIGHT_SUGGESTIONS } from './freightSuggestionGroups'

const COMMODITIES = [
  'Building materials',
  'Machinery, Large Objects',
  'Lumber',
  'Paper products',
  'Produce',
  'Refrigerated food',
  'Steel',
]
const FMCSA_NAMES = ['Logs, Poles, Beams, Lumber']

export function TagInputSection() {
  const [tags, setTags] = useState<string[]>(['Produce'])
  const [limited, setLimited] = useState<string[]>(['Steel', 'Lumber', 'Produce'])
  const [grouped, setGrouped] = useState<string[]>(['Auto parts'])

  return (
    <DsSection
      id="tag-input"
      title="Tag input"
      intro="Free-text tags with suggestions, on the combobox chips. Enter, a semicolon or a comma adds a tag, but a comma inside a suggestion or an unsplittable name doesn't split it. Pasted lists split the same way. Backspace in an empty field removes the last tag."
    >
      <Demo label="suggestions + unsplittable" className="max-w-md">
        <TagInput
          value={tags}
          onChange={setTags}
          suggestions={COMMODITIES}
          unsplittable={FMCSA_NAMES}
          placeholder="Type what they haul"
          aria-label="Freight types"
        />
      </Demo>
      <Demo label="suggestionGroups" className="max-w-md">
        <TagInput
          value={grouped}
          onChange={setGrouped}
          suggestions={FREIGHT_SUGGESTIONS}
          suggestionGroups={FREIGHT_SUGGESTION_GROUPS}
          placeholder="Type what they haul"
          aria-label="Grouped freight types"
        />
      </Demo>
      <Demo label="maxTags={2}" className="max-w-md">
        <TagInput
          value={limited}
          onChange={setLimited}
          suggestions={COMMODITIES}
          maxTags={2}
          aria-label="Freight types, up to 2"
        />
      </Demo>
      <Demo label="States — aria-invalid · disabled" className="grid grid-cols-1 gap-8 sm:grid-cols-2">
        <TagInput
          value={['Steel']}
          onChange={() => undefined}
          suggestions={COMMODITIES}
          aria-invalid
          aria-label="Invalid example"
        />
        <TagInput
          value={['Steel']}
          onChange={() => undefined}
          suggestions={COMMODITIES}
          disabled
          aria-label="Disabled example"
        />
      </Demo>
    </DsSection>
  )
}
